export default function removeAuth() {
  sessionStorage.clear();
  window.location.reload();
}
